/** Synthetic persona face tiles (subset of fields needed for assignment). */
export type PersonaFaceTileMeta = {
  persona_id: string;
  gender_presentation: 'female' | 'male';
};

export const PERSONA_FACE_TILES: PersonaFaceTileMeta[] = [
  { persona_id: 'persona_01', gender_presentation: 'female' },
  { persona_id: 'persona_02', gender_presentation: 'male' },
  { persona_id: 'persona_03', gender_presentation: 'female' },
  { persona_id: 'persona_04', gender_presentation: 'male' },
  { persona_id: 'persona_05', gender_presentation: 'male' },
  { persona_id: 'persona_06', gender_presentation: 'female' },
  { persona_id: 'persona_07', gender_presentation: 'male' },
  { persona_id: 'persona_08', gender_presentation: 'female' },
  { persona_id: 'persona_09', gender_presentation: 'female' },
  { persona_id: 'persona_10', gender_presentation: 'male' },
  { persona_id: 'persona_11', gender_presentation: 'female' },
  { persona_id: 'persona_12', gender_presentation: 'male' },
  { persona_id: 'persona_13', gender_presentation: 'female' },
  { persona_id: 'persona_14', gender_presentation: 'male' },
  { persona_id: 'persona_15', gender_presentation: 'female' },
  { persona_id: 'persona_16', gender_presentation: 'male' },
];
